module.exports = __webpack_public_path__ + "img/video-placeholder-dk.42f7dcf8.jpg";